module.exports = __webpack_public_path__ + "img/credito-simple-table.b09420d0.webp";